import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import { jsx as _jsx } from "react/jsx-runtime";
import { SDUIFilterRowRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/FilterBar/SDUIFilterRowRenderer";
import { SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton } from "@faire/retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/LoadingSkeleton/SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton";
import { PersistStreamedServerComponentRenderer } from "@faire/retailer-visitor-shared/nextjs-rsc-util/PersistStreamedServerComponentRenderer";
import React from "react";
export var SDUIFilterRowRendererRSC = function(props) {
    return /*#__PURE__*/ _jsx(PersistStreamedServerComponentRenderer, {
        renderedComponentPromise: renderComponentOnServer(props),
        loadingSkeleton: /*#__PURE__*/ _jsx(SDUIFilterablePaginatedSectionFilterRowLoadingSkeleton, {}),
        suspenseKey: "filter-row-".concat(props.component.id)
    });
};
var renderComponentOnServer = /*#__PURE__*/ function() {
    var _ref = _async_to_generator(function(param) {
        var component, sectionLoggingParams, isFilterLoading;
        return _ts_generator(this, function(_state) {
            component = param.component, sectionLoggingParams = param.sectionLoggingParams, isFilterLoading = param.isFilterLoading;
            return [
                2,
                new Promise(function(resolve) {
                    resolve(/*#__PURE__*/ _jsx(SDUIFilterRowRenderer, {
                        component: component,
                        sectionLoggingParams: sectionLoggingParams,
                        isFilterLoading: isFilterLoading
                    }));
                })
            ];
        });
    });
    return function renderComponentOnServer(_) {
        return _ref.apply(this, arguments);
    };
}();
